import { Form, Input, Select, Tag, DatePicker, Button, Row, Col } from 'antd';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons/lib';
import { useTranslation } from 'react-i18next';
import { createPhoneNumberFieldConfig } from '../../../utils/formFields/phoneNumberField';
import { createDocumentDraggerFieldWithObject } from '../../../utils/formFields/documentDraggerField';

const { Option } = Select;

export const secondaryProfileInformations = ({
  setFilesList,
  filesList,
  filteredEnums,
  isFieldsLoading,
  setRemovedFiles
}) => {
  const { t } = useTranslation();

  const draggerProps = (object, name) => ({
    onRemove: () => {
      const updatedFileList = { ...filesList };

      setRemovedFiles((prevRemovedFiles) => [
        ...prevRemovedFiles,
        updatedFileList[object][name][0].id
      ]);

      if (name === 'secondary_profile_identification_photo') {
        updatedFileList.secondary_profile.secondary_profile_identification_photo =
          [];
      } else {
        delete updatedFileList[object][name];
      }
      setFilesList(updatedFileList);
    },
    beforeUpload: (file) => {
      const newFile = file;
      if (name === 'secondary_profile_identification_photo') {
        const reader = new FileReader();
        reader.onload = (e) => {
          newFile.url = e.target.result;
        };
        reader.readAsDataURL(file);
      }
      setFilesList((prevFileList) => {
        if (object in prevFileList) {
          return {
            ...prevFileList,
            [object]: {
              ...prevFileList[object],
              [name]: [newFile]
            }
          };
        }
        return {
          ...prevFileList,
          [object]: {
            [name]: [newFile]
          }
        };
      });

      return false;
    },
    fileList: filesList[object]?.[name]
  });

  const secondaryProfileInformationsFields = [
    {
      name: ['secondary_profile', 'civility'],
      rules: [{ required: true }],
      input: (
        <Select loading={isFieldsLoading}>
          {(filteredEnums || []).map((civility) => (
            <Option key={civility} value={civility}>
              <Tag>{t(`pensioners.tags.${civility}`)}</Tag>
            </Option>
          ))}
        </Select>
      )
    },
    {
      name: ['secondary_profile', 'last_name'],
      rules: [{ required: true }]
    },
    {
      name: ['secondary_profile', 'first_name']
    },
    {
      name: ['secondary_profile', 'birth_date'],
      input: <DatePicker format="DD/MM/YYYY" />
    },
    {
      name: ['secondary_profile', 'profession']
    },
    {
      name: ['secondary_profile', 'principal_language']
    },
    createPhoneNumberFieldConfig(
      'cell_phone_number',
      ['secondary_profile'],
      90
    ),
    {
      label: 'other_languages.label',
      input: (
        <Form.List name={['secondary_profile', 'other_languages']}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ name, key }) => (
                <Row justify="space-between" key={key}>
                  <Col>
                    <Button onClick={() => remove(name)}>
                      <CloseOutlined />
                    </Button>
                  </Col>

                  <Form.Item noStyle name={[name]}>
                    <Input />
                  </Form.Item>
                </Row>
              ))}
              <Button
                type="dashed"
                onClick={() => {
                  add();
                }}
                icon={<PlusOutlined />}
              >
                {t('pensioners.form.other_languages.add_button')}
              </Button>
            </>
          )}
        </Form.List>
      )
    },
    createDocumentDraggerFieldWithObject(
      'secondary_profile.criminal_record_extract',
      'secondary_profile',
      'secondary_profile_criminal_record_extract',
      draggerProps,
      t
    ),
    createDocumentDraggerFieldWithObject(
      'secondary_profile.identification_photocopy',
      'secondary_profile',
      'secondary_profile_identification_photocopy',
      draggerProps,
      t
    ),
    createDocumentDraggerFieldWithObject(
      'secondary_profile.identification_photo',
      'secondary_profile',
      'secondary_profile_identification_photo',
      draggerProps,
      t
    )
  ];

  return { secondaryProfileInformationsFields };
};
